export default __webpack_public_path__ + "static/media/decor.4e3fc1f1.svg";